<template>
  <div v-if="showAddDescription || showCreateChecklist" class="task-quick-actions">
    <button
      v-if="showAddDescription"
      class="btn-sm btn-secondary"
      @click="$emit('add-description')"
    >
      {{ __('Add') }} {{ s__('TaskDetail|Description') }}
    </button>
    <button
      v-if="showCreateChecklist"
      class="btn-sm btn-primary"
      @click="$emit('create-checklist')"
    >
      {{ s__('Checklist|Create Checklist') }}
    </button>
  </div>
</template>

<script setup>
import { __, s__ } from '@/locale'

defineProps({
  showAddDescription: { type: Boolean, default: false },
  showCreateChecklist: { type: Boolean, default: false },
})

defineEmits(['add-description', 'create-checklist'])
</script>

<style scoped>
.task-quick-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .task-quick-actions {
    width: 100%;
    justify-content: stretch;
  }

  .task-quick-actions > .btn-sm {
    flex: 1 1 calc(50% - 4px);
    min-width: 0;
    justify-content: center;
    text-align: center;
  }
}
</style>
